import React, { useState, useMemo, useEffect, useRef } from 'react';
import { Typography, Card, Grid } from "@mui/material";
import Box from '@mui/material/Box';
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import _ from 'lodash';
import Spinner2 from "../../common/Spinner/Spinner2";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import ModalComponent from '../../common/Modal/ModalComponent.js';
import partialColorCode from '../../../../jsonStore/colorCodePartial.json';
import moment from 'moment';
import { getPartialTrip, fetchSavedView, baseUrl } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import { useSelector } from 'react-redux';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';
import ActionButton from '../../../../shared/common-utilities/common/ActionButton.jsx';
import { refreshRouteAndPT, setPartialTripReducer } from '../../../../shared/ReduxStore/Reducers/partialTripReducer.jsx';
import { useDispatch } from 'react-redux';

const entity = "partialTrip";
const odataApiName = "partialTrips";
const odataApiNameFor = "partialTrips"; // Future use if need to open as popup from any plan function
let service = getSetDataService();
let dataService = dataStorageService();
let apiService = commonApiService();
const dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
// const planRelatedAction = ['Send To OBC', 'Transfer Goods', 'Split Trip', 'Insert Begin - End Action', 'Regroup', 'Delete Trip', 'Report', 'Show On Map', 'Calculate', 'Contract Out'];
const planRelatedAction = ['Send To OBC', 'Contract Out', 'Insert Begin - End Action', 'Report', 'Transfer Goods', 'Split Trip', 'Regroup', 'Delete Partial Trip', 'Show On Map', 'Calculate', 'Exchange Trailer', 'View E-CMR', 'Create E-CMR', 'Print CMR', 'Truck Appointment New', 'Truck Appointment Add To', 'Truck Appointment Overview', 'Insert Shipping Line', 'E-mail Outsource Confirmation', 'Print Outsource Confirmation', 'Print Trip Sheet', 'E-mail Trip Sheet', 'Move To LU', 'Split Trailer', 'New Partial Trip', 'Changes Status', 'Batch Trip Creation', 'Insert Extra Action', 'Plan On Map'];
const defDataRelatedAction = ['Filter', 'View Columns', 'Settings'];

const PartialTrip = (prop) => {
  //#region Reference
  const prtGrid = React.useRef(null);
  const selectedDataRef = useRef({})
  //#endregion Reference

  //#region Hook Selctor

  //#endregion Hook Selctor

  const prtGriddDtaItemKey = "id";
  let gridSelectedValues = {};
  const initialSort = service.initialSort[entity];
  const partialTripRefreshReducerData = useSelector(state => state.partialTrip.isRefreshPartialTrip);
  const partialTripReducerData = useSelector(state => state.partialTrip);
  const dispatch = useDispatch();

  //#region States - Get set variables  
  const [tempPartialTripsData, setTempPartialTripsData] = useState([]);
  const [prtGridColumnList, setPrtGridColumnList] = useState(null);
  const [tempPrtGridColumnList, setTempPrtGridColumnList] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isPartialTrip, setIsPartialTrip] = useState(true);
  const [loadedGridData, setLoadedGridData] = useState(tempPartialTripsData);
  const [routeGuidesData, setRouteGuidesData] = useState([]);
  const [planDepartmentData, setPlanDepartmentData] = useState([]);
  const [planSubdepartmentData, setPlanSubdepartmentData] = useState([]);
  
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const userID = localStorage.getItem('userID');

  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const currStatusValue = "All";
  const startDate = useRef(new Date());
  const days = useRef(300);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  
  const filterData = dataService.getLocalStorageData("statuses");
  const statusData = [
    { code: 1, status: 'All' },
    { code: filterData, status: 'Executed' },
    { code: 3, status: 'Not Executed' },
  ];
  const selectedStatus = useRef(statusData[0])
  let prtFilterComponents = [
    { type: 'DatePicker', key: 'startingDate', value: startDate.current, label: 'Start Date', placeholder: 'Start date...' },
    { type: 'NumericTextBox', key: 'daysToShow', value: days.current, label: 'Days To Show', placeholder: 'Please enter value', relationalField: 'startingDate', },
    { type: 'DropDownList', key: 'status', value: selectedStatus.current, label: 'Status Description', data: statusData },
  ];
  const [tripId, setTripId] = useState(null);
  const [colorCodeData, setColorCodeData] = useState({ gridColorCode: [], flag: "partial" });
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const rowColorField = 'statusDescription';
  const editableColumn = ['planInfo'];
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [changeToChildPT, setChangeToChildPT] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [canExecute, setCanExecute] = useState([]);
  const [openResModal, setOpenResModal] = useState(false);
  let refreshTime = JSON.parse(dataService.getLocalStorageData('refreshTime'))
  const hasApiLoadedData = JSON.parse(dataService.getLocalStorageData("apiLoadedData"));
  const refTime = useSelector(state => state.refreshTime.refreshTime);
  const customActionsData = JSON.parse(dataService.getLocalStorageData('customActions')) || [];
  const customActionsPartialTrips = customActionsData?.filter(action => action?.form === "Partial Trips");
  const metaData = JSON.parse(dataService.getLocalStorageData("metaData"))

  //#endregion States

  //#region Hooks  
  useEffect(() => {
    // setIsLoading(true);

    const prtColorCodeList = localStorage.getItem('prtColorCodeList');
    if (_.isNil(prtColorCodeList)) {
      getColorCode();
    } else {
      setColorCodeData(JSON.parse(prtColorCodeList));
    }
    // if (!hasApiLoadedData) { // Removed this to call it everytime as per requirement of alex in #1859
      getRouteGuides();
      getPlanDepartments();
      getPlanSubdepartments();
      dataService.setLocalStorageData("apiLoadedData", true);
    // }

    setIsApiLoaded(true);
    setGridColumns(entity);

    let tempFilterData = [];
    let mergedArray = []
    if(!prop?.isChild) {
      if (days.current > 0) {
        tempFilterData.push({ field: 'startingDate', value: service.dateFormat(startDate.current, 'startDate') + (days.current > 0 ? ".." + service.dateFormat(startDate.current, 'startDate', days.current) : ""), isLast: false, type: 'Edm.Date' });
      } else {
        tempFilterData.push({ field: 'startingDate', value: ">=" + service.dateFormat(startDate.current, 'startDate'), isLast: false, type: 'Edm.Date' });
      }
      tempFilterData.push({ field: 'status', value: '=' + currStatusValue, isLast: false, type: 'Edm.String' });
      let userData = service.getUserFilterData(entity);
      mergedArray = tempFilterData.concat(userData);
    }
    setInitialFilter(mergedArray);
  }, []);

  useEffect(() => {
    if (!_.isNil(partialTripReducerData) && (prop.guid == partialTripReducerData.guid)) {
      setTripId(partialTripReducerData.tripNumber);
    }
  }, [partialTripReducerData])

  useEffect(() => {
    if (tripId != null && window.location.hash.includes("#/CustomView") && prop?.isChild) {
      sendApi()
    }
  }, [tripId]);

  
  const getRouteGuides = () => {
    const url = `${baseUrl}/routeGuides`;
    apiService.get(url).then((response) => {
      setRouteGuidesData(response.value)
      dataService.setLocalStorageData('routeGuides', JSON.stringify(response.value));
    })
  }

  const getPlanDepartments = () => {
    const url = `${baseUrl}/departments?$filter=(planDepartment eq true)`;
    apiService.get(url).then((response) => {
      setPlanDepartmentData(response.value)
      dataService.setLocalStorageData('planDepartments', JSON.stringify(response.value));
    })
  }

  const getPlanSubdepartments = () => {
    const url = `${baseUrl}/subdepartments?$filter=(planSubdepartment eq true)`;
    apiService.get(url).then((response) => {
      setPlanSubdepartmentData(response.value)
      dataService.setLocalStorageData('planSubdepartments', JSON.stringify(response.value));
    })
  }

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityName + 'ColumnList');
    if (!_.isNil(columnList)) {
      setPrtGridColumnList(JSON.parse(columnList));
      getColList(entity, JSON.parse(columnList));
      return true;
    }

    if(!_.isNil(metaData) || metaData !== "undefined") {
      service.entityDefinitions(metaData, entityName).then((tempFieldList) => {
        tempFieldList.unshift({
          field: 'ActionColumn',
          title: 'Action',
          visible: true,
          width: 60,
          locked: false,
          order: 'asc',
          groupBy: false,
        });
        localStorage.setItem(entityName + 'ColumnList', JSON.stringify(tempFieldList));
        setPrtGridColumnList(tempFieldList);
        getColList(entity, tempFieldList);
      })
    }
  }

  const getDefaultColList = (dcolsString, entityName, gridcolumns) => {
    if (!_.isNil(dcolsString) && dcolsString != "undefined") {
      const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
      const defaultColumnList = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field) || item.field == 'instructionsExist' || item.field == 'qualificationsExist' || item.field == 'ActionColumn'
      });
      if (defaultColumnList.length == 0) {
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempPrtGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnList, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(sortedArr));
        setTempPrtGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setPrtGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempPrtGridColumnList(gridcolumns);
    }
  }

  const getColList = (entityName, gridcolumns) => {
    const ptUrl = `${fetchSavedView}?$filter=(title eq '${odataApiName}' and userID eq '${userID}')`;
    const dcolsStringPT = localStorage.getItem("defaultColumnSetting");
    apiService.get(ptUrl).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"], null, null, null, null, savedViewRes.value[0]["@odata.etag"]).then(readResPT => {
          if (readResPT !== undefined && readResPT !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readResPT);
            const defaultViewExist = readResPT[odataApiName]?.savedViews?.filter(item => item.defaultView);
            if (defaultViewExist?.length > 0 && defaultViewExist[0]?.subviews?.length > 0) {
              setCanExecute(defaultViewExist);
              const favFilterExist = defaultViewExist[0]?.subviews?.filter(subView => subView.isDefaultFilter);
              if (favFilterExist?.length > 0) {
                setTempPrtGridColumnList(defaultViewExist[0].columns);
              }
            } else if (readResPT[odataApiName]?.columns?.length !== 0) {
              localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(readResPT[odataApiName]?.columns));
              setTempPrtGridColumnList(readResPT[odataApiName]?.columns);
            } else {
              getDefaultColList(dcolsStringPT, entityName, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsStringPT, entityName, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      updateSendApi(loadSelectionValue);
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect((e) => {
    if (!_.isNil(tempPrtGridColumnList)) {
      setNextDataUrl(null);
      updateSendApi(loadSelectionValue);
    }
  }, [tempPrtGridColumnList]);

  useEffect(() => {
    if (prop.isPin !== undefined && prop.isPin !== null) {
      setIsPartialTrip(prop.isPin);
    }
  }, [prop.isPin])

  useEffect(() => {
    if (partialTripRefreshReducerData) {
      setNextDataUrl(null);
      setParamsData({ ...paramsData });
    }
  }, [partialTripRefreshReducerData])
  
  //#endregion Hooks

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsPartialTrip(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      // Start -> Code for load default view in child screen of custom view
      // Keep this line only setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      if(window.location.hash.includes("#/CustomView") && prop?.isChild) 
        setParamsData(null)
      else
        setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      // End
      setIsApiCallRequired(value.isApiCall);
      setTempPrtGridColumnList(value.columns);
      setCanExecute([]);
      if(value.filter) {
        startDate.current = new Date(service.handleFilterData(value.filter,'startingDate ge'))
        days.current = service.handleFilterData(value.filter).daysBetween
        let statusCode = service.handleFilterData(value.filter,'status eq')
        const statusObject = statusData.find(obj => obj.code === statusCode);
        if(statusObject) {
          selectedStatus.current = (statusObject)
        } else {
          if(statusCode == null)
            selectedStatus.current = { code: 3, status: 'Not Executed' }
          else
            selectedStatus.current = { code: 1, status: 'All' }
        }
      }
    } else if (flag == 'deleteTrip') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData });
    } else if (flag === 'refresh') {
      sendApi(null, loadSelectionValue);
      if(window.location.hash.includes("#/CustomView")) {
        dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
      }
    } else if (flag === 'selectedValues') {
      if(value != '') {
        gridSelectedValues = value;
        selectedDataRef.current = value
      }
    } else if (flag === 'columnsVisible') {
      setTempPrtGridColumnList(value);
    } else if (flag === 'openResModal') {
      setOpenResModal(value);
    }else if(flag === "updateDays"){
      days.current = value
    }else if(flag === "updateStartDate"){
      startDate.current = value
    }else if(flag === "updateStatus"){
      selectedStatus.current = value
    }
  }

  const sendApi = (val, size, type=null) => {
    let paramsFilter = prop?.params && service.generateConditionString(prop?.params?.parameters);
    // let filter = paramsData?.filter ? `$filter=(${prop?.params ? paramsFilter : paramsData?.filter})` : null;
    let filter = ''
    if('isChild' in prop) {
      if(prop?.isChild) {
        if(tripId)
          filter = paramsData?.filter ? `$filter=(${prop?.params ? paramsFilter : paramsData?.filter} + ${(tripId && tripId != "") && `and id eq ${tripId}`})` : (tripId && tripId != "")  && `$filter=(id eq ${tripId})`;
        else 
          return
      }
      else {
        filter = paramsData?.filter ? `$filter=(${prop?.params ? paramsFilter : paramsData?.filter})` : null;
      }
    } else {
      filter = paramsData?.filter ? `$filter=(${prop?.params ? paramsFilter : paramsData?.filter})` : null;
    }
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if(!prop?.isChild) { // remove this condition when partialtrip and custom view PT have saperate view
      if (canExecute?.length > 0) {
        return;
      }
    }
    if (tempPrtGridColumnList !== null && tempPrtGridColumnList !== undefined && tempPrtGridColumnList?.length > 0 && !prop?.customView) {
      if(type != "autoRefresh") {
        setIsLoading(true);
      }
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempPrtGridColumnList?.filter(item => item.field !== 'instructionsExist' && item.field !== 'ActionColumn').map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }

      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getPartialTrip, params, `${selectFields}`, oDataNextLink, size, null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemovePT = response.error.message.split("'")[1];
            setChangeToChildPT({ type: "sort", value: sortToRemovePT });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemovePT = response.error.message.split("'")[1];
            setChangeToChildPT({ type: "filter", value: filterToRemovePT });
          } else if (response?.error?.message?.includes('not filterable')) {
            const fieldToRemovePT = response.error.message.split("'")[1];
            setChangeToChildPT({ type: "filter", field: fieldToRemovePT });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);
            let tempData = [];
            if (val == 'Scroll' && tempPartialTripsData !== null && tempPartialTripsData !== undefined && tempPartialTripsData.length > 0) {
              tempPartialTripsData.forEach(tempPartialTrip => {
                tempData.push(tempPartialTrip);
              });
              response.value.map(temp => {
                tempData.push(temp)
              })
            }
            // Update the data based on the response
            else {
              tempData = response.value;
            }
            tempData = setColorCodeAndDate(tempData);
            setIsApiLoaded(true);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }
            setmyGridData(tempData);
            setLoadedGridData(tempData);
            setTempPartialTripsData(tempData);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      if(!prop?.isChild)
        sendApi(null, size);
    }, 250);
  }, [sendApi]);

  const onLoadSelectionChange = (e) => {
    let value = e.value;
    setloadSelectionValue(value);
    sendApi(null, value);
  }

  // --- Common methods END ---

  //#endregion Methods

  //#region Not in use

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const closeConfirmationModal = () => {
    setopenConfirmationModal(false);
  }

  const getColorCode = () => {
    setColorCodeData(prevState => ({ ...prevState, gridColorCode: [...prevState.gridColorCode, partialColorCode] }));
    // apiService.fetchStatusColorCodeData().then(response => {
    //   if (response && response.value) {
    //     setColorCodeData(response.value);
    //   } else {
    //     console.error("Response or response.value is undefined");
    //   }
    // });
  }
  const onOkClick = () => {
    prop?.sendDataToParent(selectedDataRef.current)
  }
  const closePopup = () => {
    prop?.onClose();
  }
  const setColorCodeAndDate = (arrList) => {
    // Need to Opetimize
    let partialGridColorCode = colorCodeData?.gridColorCode[0]?.map(prtColor => prtColor);
    const dateColumns = tempPrtGridColumnList?.filter(item => item.type === 'Edm.Date' || item.type === 'Edm.DateTimeOffset').map(item => item.field);
    const timeColumns = tempPrtGridColumnList?.filter(x => x.field.includes('Time') && x.type === 'Edm.String').map(item => item.field);
    const enumColumns = prtGridColumnList?.filter(field => field.enumField).map(item => ({
      field: item.field,
      enumName: item.enumName
    }));
    const enumCaptions = dataService.getLocalStorageData('enumCaptions') ? JSON.parse(dataService.getLocalStorageData('enumCaptions')) : [];
    arrList?.forEach(e => {
      let filterdObj = partialGridColorCode?.find(o => Number(e.status) === o.colorCode);
      if (!_.isEmpty(filterdObj)) {
        e.colorPlanningHex = filterdObj.colorPlanningHex;
        e.textColorPlanningHex = filterdObj.textColorPlanningHex;
      }

      timeColumns?.forEach(column => {
        if (e[column]) {
          e[column] = moment(e[column], 'HH:mm:ss').format('HH:mm');
        }
      });
      dateColumns?.forEach(column => {
        if (new Date(e[column]).getYear() < 0) {
          e[column] = '';
        } else {
          e[column] = new Date(e[column]);
        }
      })

      enumColumns?.forEach(column => {
        if (e[column.field]) {
          if (enumCaptions?.find(enumColumn => enumColumn?.entityName === column?.enumName)) {
            for (const caption of enumCaptions) {
              if (caption?.entityName === column?.enumName && caption?.values?.length > 0 && caption?.values?.filter(value => value?.name === e[column.field]).map(x => x?.caption)?.length > 0) {
                e[column.field] = caption?.values?.filter(value => value.name === e[column.field]).map(x => x.caption)[0];
              }
            }
          }
        }
      })
    });
    return arrList;
  }

  useEffect(()=> {
    if(refreshTime != null) {
      const fetchData = () => {
        // Your API call logic here
          sendApi(null, loadSelectionValue, "autoRefresh")
         
          if(window.location.hash.includes("#/CustomView")) {
            dispatch(refreshRouteAndPT({ isRefreshRouteAndPT: !partialTripReducerData.isRefreshRouteAndPT }))
          }
      };

      const intervalId = setInterval(fetchData, refreshTime * 1000);
      // Clean up the interval on component unmount
      return () => clearInterval(intervalId);
    }
  },[loadSelectionValue,tempPrtGridColumnList,refreshTime,paramsData,refTime])

  const onGridClick = () => {
    if (window.location.hash.includes("#/CustomView") && dataService.getLocalStorageData('currentActive') !== odataApiName && !openResModal) {
      dataService.setLocalStorageData('currentActive', odataApiName);
    }
  }

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}

      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} onClick={onGridClick}>

        {isPartialTrip &&
          <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Partial Trips</Typography>
          </Box>}

        <Box sx={{ p: 0, display: 'flex' }} className="filterbar-bg">
          <Grid
            item={true}
            elevation={0}
            pl={0}
            sx={{ flexGrow: 1, }}
            className='grid-movement'
            xs component={Card}
          >
            {isApiLoaded && <DataGridComponent
              {...prop}
              gridRef={prtGrid}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
              entity={entity}
              gridNewData={myGridData}
              loadedGridData={loadedGridData}
              tempGridData={tempPartialTripsData}
              gridColumnList={prtGridColumnList ? prtGridColumnList : []}
              gridTempColumnList={tempPrtGridColumnList ? tempPrtGridColumnList : []}
              gridSort={initialSort}
              isItemVisible={false}
              gridInitialFilter={initialFilter}
              isShowGridHeader={isPartialTrip}
              griddDtaItemKey={prtGriddDtaItemKey}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              selectableMode={prop?.params && 'single'}
              gridPlanAction={planRelatedAction}
              griddefDataRelatedAction={defDataRelatedAction}
              gridFilterComponents={prtFilterComponents}              
              routeGuidesData={routeGuidesData}
              planDepartmentData={planDepartmentData}
              planSubdepartmentData={planSubdepartmentData}
              colorStatus={rowColorField}
              editableColumn={editableColumn}
              onLoadSelectionChange={onLoadSelectionChange}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={(prop.guid == partialTripReducerData.guid && partialTripReducerData?.removePartialTrip) ? 0 : totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              changeToChild={changeToChildPT}
              isDraggable={true}
              customActions={customActionsPartialTrips}
            />}
          </Grid>
        </Box>
        <ActionButton onOkClick={onOkClick} closePopup={closePopup} />
        <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />
      </Grid>
    </>
  )
};

export default PartialTrip;